import * as actionTypes from "./actionTypes";

export const leaveAlliance = (newEmperorId: number | null) => ({
  type: actionTypes.LEAVE_ALLIANCE,
  newEmperorId
})

export const foundAlliance = (allianceName: string) => ({
  type: actionTypes.FOUND_ALLIANCE,
  allianceName
})

export const applyAlliance = (allianceName: string) => ({
  type: actionTypes.APPLY_ALLIANCE,
  allianceName
})

export const cancelApplication = (governorateId: number) => ({
  type: actionTypes.CANCEL_APPLICATION,
  governorateId
})

export const acceptApplication = (governorateId: number) => ({
  type: actionTypes.ACCEPT_APPLICATION,
  governorateId
})

export const expelMember = (governorateId: number) => ({
  type: actionTypes.EXPEL_MEMBER,
  governorateId
})

export const toggleWarApplication = (apply: boolean) => ({
  type: actionTypes.TOGGLE_WAR_APPLICATION,
  apply
})

export const editNote = (noteType: string, note: string) => ({
  type: actionTypes.EDIT_NOTE,
  noteType,
  note
});

export const abdicate = (password: string, newEmperorId: number) => ({
  type: actionTypes.ABDICATE,
  password,
  newEmperorId
});

export const toggleCommander = (govId: number) => ({
  type: actionTypes.TOGGLE_COMMANDER,
  govId
});

export const handoverEmperor = (govId: number) => ({
  type: actionTypes.HANDOVER_EMPEROR,
  govId
});
